var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.86808e-07V1.5H5.02681e-07V7.86808e-07H18Z",
    fill: "#717171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5V6.5H5.02681e-07V5H18Z",
    fill: "#717171"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10V11.5H5.02681e-07V10H18Z",
    fill: "#717171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideButton);
export default __webpack_public_path__ + "static/media/sideButton.5df1fe8c01ff189cb0eeaa59f5b663e7.svg";
export { ForwardRef as ReactComponent };